import styled from 'styled-components';

import { FormInput } from '@catalyze/ui';

export const Container = styled.ul`
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 22.5rem;

    & > *:not(:last-child) {
        margin-bottom: 1.25rem;
    }
`;

export const Row = styled.li`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
`;

export const StyledFormInput = styled(FormInput)`
    max-width: 9.25rem;
`;
